import { AppNS } from 'app';
import {
  AGENCY_TYPES,
  DISCIPLINES,
} from 'app/main/agency/profile/qualifications-sections/sections/disciplines-picker/validation-schema';
import { Params } from 'app/types';
import * as Yup from 'yup';

export interface FormValues {
  discipline: string;
}

export const defaultValues: FormValues = {
  discipline: '',
};

const detailsFields = {
  discipline: Yup.string().required('Please pick  discipline'),
};

export const getValidationSchema = () => {
  return Yup.object({
    ...detailsFields,
  });
};

export const getDisciplinesByParents = (parents: string[]): Params[] => {
  return DISCIPLINES.filter((discipline) => parents.includes(discipline.parent));
};

export const getParentsByDisciplines = (disciplines: string[]): string[] => {
  const types = DISCIPLINES.filter((discipline) => disciplines.includes(discipline.id)).map(
    (discipline) => discipline.parent
  );
  return [...new Set(types)];
};

export const getDisciplinesForList = (excludes: AppNS.DisciplineId[]): Params[] => {
  let currentParent = '';
  return DISCIPLINES.filter((discipline) => !excludes.includes(discipline.id)).reduce((acc: Params[], discipline) => {
    const type = getTypeById(discipline.parent);
    if (currentParent !== discipline.parent) {
      acc.push({ id: 'optgroup', name: type?.name || '' });
      currentParent = discipline.parent;
    }
    acc.push(discipline);
    return acc;
  }, []);
};

export const getDisciplinesById = (id: string): Params | undefined => {
  return DISCIPLINES.find((discipline) => discipline.id === id);
};

export const getTypeById = (id: string): Params | undefined => {
  return AGENCY_TYPES.find((discipline) => discipline.id === id);
};

/**
 * When Boiler Welder or Boiler Inspection is selected, we need to exclude all other disciplines
 * And when any other discipline is selected we need to exclude Boiler Welder and Boiler Inspection
 * @param disciplines - array of discipline ids
 * @returns
 */
export const getExcludesByCurrentDisciplines = (disciplines: AppNS.DisciplineId[]): AppNS.DisciplineId[] => {
  if (disciplines.length < 1) {
    return [];
  }

  if (disciplines.includes('boilerInspection')) {
    return excludeAllButOneDiscipline(disciplines, 'boilerInspection');
  }

  if (disciplines.includes('boilerWelder')) {
    return excludeAllButOneDiscipline(disciplines, 'boilerWelder');
  }

  // if there's no boiler related discipline selected, exclude both boiler disciplines
  return ['boilerWelder', 'boilerInspection', ...disciplines];
};

function excludeAllButOneDiscipline(disciplines: AppNS.DisciplineId[], disciplineToExclude: AppNS.DisciplineId) {
  return [
    ...DISCIPLINES.filter((discipline) => ![disciplineToExclude].includes(discipline.id)).map(
      (discipline) => discipline.id
    ),
    ...disciplines,
  ];
}
